import {
	FaCheckCircle,
	FaBriefcase,
	FaPalette,
	FaEnvelope,
	FaHashtag,
	FaMailBulk,
	FaAd,
	FaHome,
	FaUsers,
	FaPlus,
	FaMapMarkerAlt,
	FaUserFriends,
	FaBullseye,
	FaChartLine,
	FaCalendarAlt,
	FaComments,
	FaCog,
} from 'react-icons/fa';

// Service feature icons mapping
export const featureIcons = {
	business: <FaBriefcase className='text-[rgba(204,_29,_185,_0.8)] mr-2' />,
	design: <FaPalette className='text-[rgba(204,_29,_185,_0.8)] mr-2' />,
	email: <FaEnvelope className='text-[rgba(204,_29,_185,_0.8)] mr-2' />,
	social: <FaHashtag className='text-[rgba(204,_29,_185,_0.8)] mr-2' />,
	mail: <FaMailBulk className='text-[rgba(204,_29,_185,_0.8)] mr-2' />,
	ads: <FaAd className='text-[rgba(204,_29,_185,_0.8)] mr-2' />,
	listing: <FaHome className='text-[rgba(204,_29,_185,_0.8)] mr-2' />,
	clients: <FaUsers className='text-[rgba(204,_29,_185,_0.8)] mr-2' />,
	more: <FaPlus className='text-[rgba(204,_29,_185,_0.8)] mr-2' />,
	check: <FaCheckCircle className='text-[rgba(204,_29,_185,_0.8)] mr-2' />,
	location: <FaMapMarkerAlt className='text-[rgba(204,_29,_185,_0.8)] mr-2' />,
	audience: <FaUserFriends className='text-[rgba(204,_29,_185,_0.8)] mr-2' />,
	target: <FaBullseye className='text-[rgba(204,_29,_185,_0.8)] mr-2' />,
	analytics: <FaChartLine className='text-[rgba(204,_29,_185,_0.8)] mr-2' />,
	calendar: <FaCalendarAlt className='text-[rgba(204,_29,_185,_0.8)] mr-2' />,
	chat: <FaComments className='text-[rgba(204,_29,_185,_0.8)] mr-2' />,
	management: <FaCog className='text-[rgba(204,_29,_185,_0.8)] mr-2' />,
};
